import { render, staticRenderFns } from "./HealthScoreDetailModal.vue?vue&type=template&id=6a2977c5&scoped=true"
import script from "./HealthScoreDetailModal.vue?vue&type=script&lang=js"
export * from "./HealthScoreDetailModal.vue?vue&type=script&lang=js"
import style0 from "./HealthScoreDetailModal.vue?vue&type=style&index=0&id=6a2977c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2977c5",
  null
  
)

export default component.exports